import React from "react";
import "./Deals.scss";
import SideMenu2 from "../../components/SideMenu2/SideMenu2";
import { useStoreState, useStoreActions } from "easy-peasy";
import promotionIcon from "../../images/promotionIcon.svg";
import { ReactSVG } from "react-svg";
import * as conf from "../../../config";
import * as dayjs from "dayjs";
import "dayjs/locale/ru";
import { Link } from "react-router-dom";

const Deals = () => {
  dayjs.locale("ru");
  const news = useStoreState((state) => state.deal.deals);
  const totalCount = useStoreState((state) => state.deal.totalCount);
  const pageNumber = useStoreState((state) => state.deal.pageNumber);
  const getApis = useStoreActions((actions) => actions.deal.getDeals);
  const setPageNumber = useStoreActions(
    (actions) => actions.deal.setPageNumber
  );
  const namberOfPages = [...Array(Math.ceil(totalCount / 5)).keys()].map(
    (el) => el + 1
  );

  const nextPage = async () => {
    if (pageNumber < namberOfPages[namberOfPages.length - 1]) {
      await getApis({
        limit: 5,
        sort: { date: "DESC" },
        start: 5 * pageNumber,
      });
      setPageNumber(pageNumber + 1);
    }
  };

  const prevPage = async () => {
    if (pageNumber > 1) {
      await getApis({
        limit: 5,
        sort: { date: "DESC" },
        start: 5 * (pageNumber - 2),
      });
      setPageNumber(pageNumber - 1);
    }
  };

  const goToPage = async (numb) => {
    await getApis({
      limit: 5,
      sort: { date: "DESC" },
      start: 5 * (numb - 1),
    });
    setPageNumber(numb);
  };

  return (
    <div className="mainDeals">
      <div className="navLine"></div>
      <div className="container">
        <SideMenu2 />
        {news.length > 0 && (
          <div className="main">
            <div className="header">Акции</div>
            <div className="cardsContainer">
              {news.map((el, index) => (
                <React.Fragment key={index}>
                  <div className="card">
                    <div className="pic">
                      <Link to={"/deals/" + el.slug}>
                        {el.pic && (
                          <img
                            src={conf.API_HOST + el.pic.url}
                            alt="promotion"
                          />
                        )}
                        {!el.pic && <ReactSVG src={promotionIcon} />}
                      </Link>
                    </div>
                    <div className="info">
                      <h3>{el.title}</h3>
                      <h4>
                        C {dayjs(el.start).format("DD MMMM")} до{" "}
                        {dayjs(el.end).format("DD MMMM")}
                      </h4>
                      <div
                        className="text ql-editor"
                        dangerouslySetInnerHTML={{ __html: el.description }}
                      ></div>
                    </div>
                  </div>
                  {index < news.length - 1 && (
                    <div key={el.id + "n"} className="divider"></div>
                  )}
                </React.Fragment>
              ))}
            </div>
            <div className="pagination">
              <span
                className="material-icons leftBtn"
                onClick={() => prevPage()}
              >
                arrow_back_ios
              </span>
              {namberOfPages.map((el, index) => (
                <span
                  key={index}
                  className={pageNumber == el ? "active numbers" : "numbers"}
                  onClick={() => goToPage(el)}
                >
                  {el}
                </span>
              ))}
              <span
                className="material-icons rghtBtn"
                onClick={() => nextPage()}
              >
                arrow_forward_ios
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

Deals.getInitialProps = async (props) => {
  if (props.isServer) {
    if (props.match.params.id) {
      await props.store.dispatch.deal.getDealSlug(props.match.params.id);
      if (
        props.store.getState().deal.chosenDeal.id &&
        props.store.getState().deal.chosenDeal.pic
      ) {
        props.store.dispatch.popup.setPicture(
          props.store.getState().deal.chosenDeal.pic.url
        );
      }
    }
    await props.store.dispatch.deal.getDeals({
      limit: 5,
      sort: { createdAt: "DESC" },
    });
    await props.store.dispatch.deal.getDealsCount();
  } else {
    const store = require("../../client");
    if (props.match.params.id) {
      await store.default.dispatch.deal.getDealSlug(props.match.params.id);
      if (
        store.default.getState().deal.chosenDeal.id &&
        store.default.getState().deal.chosenDeal.pic
      ) {
        store.default.dispatch.popup.setPicture(
          store.default.getState().deal.chosenDeal.pic.url
        );
      }
    }
    if (store.default.getState().deal.deals.length < 1) {
      await store.default.dispatch.deal.getDeals({
        limit: 5,
        sort: { createdAt: "DESC" },
      });
      await store.default.dispatch.deal.getDealsCount();
    }
  }
  return { whatever: "stuff" };
};

export default Deals;
